import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getSchools, getClasses, signupTeacher, signupTeacherRequest } from '../../redux';
import MenuItem from 'material-ui/MenuItem';
import TeacherSignupForm from './TeacherSignupForm';

function TeacherSignupFormContainer (props) {
    const navigate = useNavigate();

    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        email: "",
        school: "", // dropdown menu
        password: "",
        errMsg: "",
        class: "",
    });

    useEffect(() => {
        props.getSchools();
        props.getClasses();
    }, []);

    const getMappedSchoolOptions = () => {
        return props.schools !== undefined ? props.schools.map((school, index) => {
            return (<MenuItem
                        key={index + school}
                        value={school.name}
                        primaryText={school.name}
                        id="school"
                    />)
        }) : null;
    }

    const getMappedClassOptions = (inputSchool) => {
        return props.classes !== undefined ? props.classes
                .filter(classObject => classObject.schoolName === inputSchool && classObject.status === "Active")
                .map((classObject, index) => {
                    return (<MenuItem
                                key={index + classObject.name}
                                value={classObject.name}
                                primaryText={classObject.name}
                                id="class"
                            />);
                })
                : null;
    }

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }

    const handleDropdownChangeSchool = (e) => {
        setState({
            ...state,
            school: e.target.innerText.trim()
        });
    }

    const handleDropdownChangeClass = (e) => {
        setState({
            ...state,
            class: e.target.innerText.trim()
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.firstName === "" ||
            state.lastName === "" ||
            state.email === "" ||
            state.password === "" ||
            state.school === "") {
            setState({
                ...state,
                errMsg: "Please fill out all the fields."
            })
        } else {
            const school = props.schools.find(school => school.name === state.school)
            const classObject = props.classes.find(classObject => classObject.name === state.class)
            if (classObject !== undefined) {
                props.signupTeacherRequest({
                    firstName: state.firstName.trim(),
                    lastName: state.lastName.trim(),
                    email: state.email.trim(),
                    school: school._id,
                    password: state.password,
                    type: "teacher",
                    classes: []
                }, classObject);
            } else {
                props.signupTeacher({
                    firstName: state.firstName,
                    lastName: state.lastName,
                    email: state.email,
                    school: school._id,
                    password: state.password,
                    type: "teacher",
                    classes: []
                });
            }
            navigate("/teacher")
        }
    }

    let authErrCode = props.authErrCode.signup.status;

    let errMsg = state.errMsg;

    if (authErrCode < 500 && authErrCode > 399) {
        errMsg = "An account with that email has already been created.";

    } else if (authErrCode > 499) {
        errMsg = "Server error!";
    }

    return (
        <TeacherSignupForm
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleDropdownChangeSchool={handleDropdownChangeSchool}
            handleDropdownChangeClass={handleDropdownChangeClass}
            school={state.school}
            schoolOptions={getMappedSchoolOptions()}
            class={state.class}
            classOptions={getMappedClassOptions(state.school)}
            firstName={state.firstName}
            lastName={state.lastName}
            email={state.email}
            password={state.password}
            errMsg={errMsg}/>
    );
}

export default connect(state => state.root, { getSchools, getClasses, signupTeacher, signupTeacherRequest })(TeacherSignupFormContainer);
